import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner7 from '../assets/banner7.jpg';

export default function HomeBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if (ready) {
		return (
			<div className="MainBodySection">
				<div
					style={{
						width: "100%",
						height: "calc(100vh - var(--topBarHeight))",
						position: "relative",
						overflow: "hidden"
					}}
				>
					{banners.map((banner, i) => (
						<div
							key={i}
							style={{
								backgroundImage: `url(${banner})`,
								backgroundAttachment: "fixed",
								backgroundSize: "cover",
								backgroundPosition: "center",
								width: "100%",
								height: "100%",
								position: "absolute",
								top: 0,
								left: 0,
								transition: "opacity 1.5s ease-in-out",
								opacity: i === bgIndex ? 1 : 0,
							}}
						/>
					))}

					{/* gradient overlay */}
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
							position: "relative",
							zIndex: 1
						}}
					>
						<div className="container">
							<div className="row">
 								<div 
									className="col-md-9 p-5" 
								>
									<h1
										className="font-bold text-light"
										style={{
											fontSize: "38px",
											paddingTop: "40px",
											textTransform: "capitalize",
										}}
									>
										"Don’t Let Vulnerability Silence a Childhood"
									</h1>

									<h1
										className="font-light text-light"
										style={{
											fontSize: "20px",
											paddingTop: "20px",
											paddingBottom: "10px",
										}}
									>
										Together, we can turn tears into smiles and fear into hope.								
									</h1>


									
									
									
									<div className="mt-5">
										<button
											className="btn btn-padded btn-rounded btn-primary"
											onClick={() => {
												appContext.navTo({
													item: 'about_us'
												})
											}}
										>
											Learn More...
										</button>
									</div>

								</div>

								

							</div>
						</div>
					</div>

				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
